import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { routes } from '@app/app.routes';
import { provideMockApiLayer } from '@app/mock-api/mock-api.providers';

import { authBearerInterceptor } from '@core/platform-auth/auth-bearer.interceptor';

const mockApiLayer = provideMockApiLayer();

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(MatSnackBarModule),
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        horizontalPosition: 'center',
        verticalPosition: 'top',
      },
    },
    provideHttpClient(withInterceptors([authBearerInterceptor, ...mockApiLayer.interceptors])),
    ...provideTranslateService({ fallbackLang: 'pt-BR' }),
    ...provideTranslateHttpLoader({ prefix: '/i18n/', suffix: '.json' }),
    ...provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
  ],
};
